/**
 * Các hằng số cấu hình bảng tính và định danh Adapter nguồn
 * Cột STT mặc định là số thứ tự hàng của Google Sheets (Row Headers: 1, 2, 3...)
 * Cột A trực tiếp chứa nội dung câu văn truyện (Story Lines)
 */
export const SPREADSHEET_CONFIG = {
  columns: [
    { key: 'A', width: 850, label: 'Nội dung nghiệp vụ (Story Lines)' },
    { key: 'B', width: 130, label: 'Trạng thái xử lý' },
    { key: 'C', width: 140, label: 'Bộ phận liên quan' },
    { key: 'D', width: 130, label: 'Dự toán (VND)' },
    { key: 'E', width: 130, label: 'Thực chi (VND)' },
    { key: 'F', width: 130, label: 'Chênh lệch (VND)' },
  ],
  defaultRows: 150,
};

// Hằng số định danh Adapter nguồn (dùng chung giữa BE và FE)
// Không để lộ tên domain hoặc website truyện thực tế ở Frontend
export const ADAPTER_SOURCES = {
  SOURCE_1: 's1',    // Kho Dữ liệu 1 (TruyenFull)
  SOURCE_2: 's2',    // Kho Dữ liệu 2 (VivuTruyen)
  ALL: 'all',        // Tìm kiếm đa nguồn gộp
  TRUYENFULL: 's1',  // Tương thích ngược
  VIVUTRUYEN: 's2',  // Tương thích ngược
};

// Adapter nguồn mặc định (mã 's1')
export const DEFAULT_SOURCE = ADAPTER_SOURCES.SOURCE_1;

// Mặc định KHÔNG gán truyện nào khi mở trang (để bảng trống)
export const DEFAULT_STORY_ID = '';
export const DEFAULT_CHAPTER_ID = '';

// Danh sách trạng thái ngụy trang kế toán / kiểm toán
export const FAKE_STATUSES = [
  'Đã hoàn thành',
  'Đang xử lý',
  'Đã phê duyệt',
  'Chờ kiểm toán',
  'Đạt tiêu chuẩn',
  'Đã đối soát',
];

// Danh sách phòng ban nội bộ công ty
export const FAKE_DEPARTMENTS = [
  'P. Kế toán',
  'P. Kinh doanh',
  'P. Kỹ thuật',
  'Kiểm toán nội bộ',
  'Ban điều hành',
  'Khối Vận hành',
];
